export const widthScreen = {
  small: '600pt',
  medium: '960pt',
  large: '1280pt',
};
